import { CommonHeader } from '@/components/header';
import MyPageWrapper from '@/components/layout/MyPageWrapper';
import {
  isMobileAtom,
  PAGE_NAME,
  removeSureUserId,
  Styles,
  useDetectMobile,
  useRecoil,
} from '@orcar/common-d2c';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';
import PlusBanner from '../../pages/home/PlusBanner';
import Footer from '../footer';
import MobileFooter from '../footer/components/MobileFooter';

type LayoutProps = {
  children: React.ReactNode;
  isSearchPage?: boolean;
};

const Layout = ({ children }: LayoutProps) => {
  const { pathname } = useLocation();
  const { isMobile } = useDetectMobile();

  const { setRecoilState: setIsMobile } = useRecoil(isMobileAtom);

  const isHomePage = pathname === PAGE_NAME.index;
  const isSearchPage = pathname === PAGE_NAME.search;
  const isMyPage = pathname.includes(PAGE_NAME.my_page);
  const isOrderPage = pathname === PAGE_NAME.order_confirmation;
  const isPaymentPage = pathname === PAGE_NAME.payment;

  useEffect(() => {
    setIsMobile(isMobile);
  }, [isMobile]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    removeSureUserId();
  }, []);

  return (
    <LayoutContainer
      backgroundColor={
        isSearchPage || isMyPage || isOrderPage || isPaymentPage
          ? Styles.COLOR.GREY_BG
          : Styles.COLOR.WHITE
      }
    >
      <div style={{ position: 'sticky', top: 0, zIndex: 100 }}>
        <PlusBanner isMobile={isMobile} />
      </div>
      <CommonHeader />
      <MainWrapper
        isMobile={isMobile}
        isHomePage={isHomePage}
        backgroundColor={
          isSearchPage || isMyPage || isOrderPage || isPaymentPage
            ? Styles.COLOR.GREY_BG
            : Styles.COLOR.WHITE
        }
      >
        <MyPageWrapper isMobile={isMobile}>{children}</MyPageWrapper>
      </MainWrapper>
      {isMobile && isHomePage && <MobileFooter />}
      {!isMobile && <Footer />}
    </LayoutContainer>
  );
};

export default Layout;

const LayoutContainer = styled.div<{
  backgroundColor?: string;
}>`
  position: relative;
  width: 100%;
  min-width: ${({ theme }) => theme.WIDTH.MOBILE_LAYOUT};
  min-height: 100vh;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ? backgroundColor : theme.COLOR.WHITE};
`;

const MainWrapper = styled.main<{
  isMobile: boolean;
  isHomePage: boolean;
  backgroundColor?: string;
}>`
  margin: 0 auto;
  width: ${({ isMobile }) => !isMobile && 'fit-content'};
  padding-top: ${({ isHomePage, theme }) =>
    isHomePage ? '0' : `calc(${theme.HEIGHT.PC_HEADER} + 44px)`};
  padding-bottom: ${({ theme }) => `calc(${theme.HEIGHT.FOOTER} + 60px)`};
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.COLOR.WHITE};

  ${({ isMobile, isHomePage, theme }) =>
    isMobile &&
    css`
      padding-top: ${isHomePage ? '0' : theme.HEIGHT.MOBILE_HEADER};
      padding-bottom: 0;
    `};
`;
